import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';
import enums from '../../../constants/enums';

export const getOffers = (state) => state.offers.offers;

export const getGroupedOffers = createSelector(
  getOffers,
  (offers)=>{
    const map = {
      buy: [],
      sell: [],
    };

    const sortedOffers = sortBy(offers
      .map(offer=>{
        const sortPriority = (enums.giftcardLinks[offer.payment_method_name] || {}).sortPriority || 999;
        return {
          ...offer,
          sortPriority: offer.fiat_currency_code.toLowerCase() === 'usd' ? sortPriority : sortPriority + 999,
        };
      }), 'sortPriority');

    sortedOffers.forEach(offer=> {
      map[offer.offer_type] && map[offer.offer_type].push(offer);
    });

    return map;
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Offers.selectors.js